<!--
- 购买状态（手机端）
- author: lzp
- greatTime: 2019-11-06
-->
<template lang="html">
  <div class="pay-status-container" :style="{'height': window_height+'px'}">
    <img :src="$store.state.static_img_url + 'pic/buyvip/yes.png'">
    <p class="one">支付成功</p>
    <p class="two">您已成功购买{{$route.query.name}}</p>
    <p class="three">使用过程中有任何疑问<br />请联系客服电话：023-67139735</p>
    <p class="button" @click="go">立即查看</p>
  </div>
</template>

<script>
export default {
  computed: {
    window_height() {
      return document.documentElement.clientHeight
    }
  },
  methods: {
    go() {
      this.$router.replace({path: unescape(this.$route.query.url)})
    }
  }
}
</script>

<style lang="stylus" scoped>
.pay-status-container
  background-color: #F8F8F8;
  text-align: center;
  color: #333333;
  img
    margin-top: 1.6rem;
  .one
    font-size: .48rem;
    font-weight: bold;
    margin-top: 1.1rem;
  .two
    font-size: .28rem;
    margin-top: .3rem;
  .three
    position: fixed;
    bottom: 1.6rem;
    width: 100%;
    text-align: center;
    line-height: .32rem
  .button
    display: block;
    position: fixed;
    bottom: .32rem;
    left: 50%;
    transform: translateX(-50%);
    width: 6rem;
    height: .9rem;
    color: #ffffff;
    font-size: .36rem;
    text-align: center;
    line-height: .9rem;
    border-radius: .45rem;
    background: rgba(250, 122, 80, 1)
</style>
